module.exports = __webpack_public_path__ + "static/media/join_artWork_top.f78b42d6.svg";